<template>
	<div class="main-top">
		<home-nav></home-nav>

		<!-- Trazilica banner -->
		<section id="biz-banner" class="biz-banner-area">
			<div class="overlay overlay-bg"></div>
			<div class="container">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 biz-banner-content">
						<div class="row">
							<div class="offset-xl-1 col-xl-6 col-lg-7 mt-5 mt-md-1">
								<h1 class="text-center text-md-left">Naši korisnici trebaju <span class="title-color">Vaše</span> usluge</h1>
								<p class="text-center text-md-left">Proširite prodajne kanale, primajte rezervacije online, određujte smjene, smanjite nedolaske...</p>
								<div class="btn-group mt-5 mt-md-5">
									<a href="/kontakt" class="btn fs-btn white-border">Kontaktirajte nas</a>
								</div>
							</div>
							<div class="offset-xl-1 col-xl-4 offset-lg-1 col-lg-4 mobitel-wrapper d-none d-lg-block">
								<img src="img/mobitel-figaro.png" class="mobitel img-responsive">
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Popularni saloni /-->
		<section id="biz-reviews" class="main-content-area py-3 py-md-5">
			<div class="container content-container">
				<div class="row no-gutters owl-container h-100">
					<div class="salon-gallery-carousel owl-theme">
						<div class="single-recent-blog-post item">
							<div class="row align-items-center">
								<div class="col-md-5 order-md-1">
									<img class="img-responsive" src="img/marketing.webp">
								</div>
								<div class="col-md-7 order-md-2">
									<div class="pt-3">
										<i class="fa fa-quote-left fa-2x"></i>
										<p class="title">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos quasi, nisi. Voluptate mollitia consequatur iste voluptatibus eaque facere.</p>
										<p class="pt-3"><b>Dina Kovač</b> - beauty studio Dina</p>
									</div>
								</div>
							</div>
						</div>
						<div class="single-recent-blog-post item">
							<div class="row align-items-center">
								<div class="col-md-5 order-md-1">
									<img class="img-responsive" src="img/marketing.webp">
								</div>
								<div class="col-md-7 order-md-2">
									<div class="pt-3">
										<i class="fa fa-quote-left fa-2x"></i>
										<p class="title">Ipsum impedit aliquid cumque debitis. Quas, voluptatibus! Sapiente, in, quia. Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
										<p class="pt-3"><b>Mario Horvat</b> - wellness centar Mario</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section id="featured-prednosti" class="main-content-area py-5">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
						<div class="">
							<h2 class="title-color text-center">68% ljudi u Hrvatskoj koristi web za istraživanje cijena prije klasične kupnje!</h2>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section id="prednosti" class="main-content-area py-3 py-md-5">
			<div class="container content-container">
				<div class="row">
					<div class="col-12 biz-section-title">
						<h3>Prednosti</h3>
						<p>Iskoristite sve prednosti koje Vam pruža suradnja s nama.</p>
					</div>
				</div>
				<div class="row">
					<div class="col-md-4 content-container">
						<div class="col-12 order-lg-1 wow zoomIn" data-wow-delay="0.1s" data-wow-duration="1.4s">
							<img class="img-responsive" src="img/marketingg.jpg">
						</div>
						<div class="col-12 order-lg-2">
							<div class="pt-3">
								<h4 class="title text-center mb-3">Marketing</h4>
								<p class="description text-center">Istaknite svoje usluge, cijene, akcije i promocije. Zadržite postojeće klijente i privucite nove.</p>
							</div>
						</div>
					</div>
					<div class="col-md-4 content-container">
						<div class="col-12 order-lg-1 wow zoomIn" data-wow-delay="0.1s" data-wow-duration="1.4s">
							<img class="img-responsive" src="img/kalendar.png">
						</div>
						<div class="col-12 order-lg-2">
							<div class="pt-3">
								<h4 class="title text-center mb-3">Raspored i rezervacije</h4>
								<p class="description text-center">Sistem rezervacija usklađen je s rasporedom rada kako biste maksimalno iskoristili kapacitete.</p>
							</div>
						</div>
					</div>
					<div class="col-md-4 content-container">
						<div class="col-12 order-lg-1 wow zoomIn" data-wow-delay="0.1s" data-wow-duration="1.4s">
							<img class="img-responsive" src="img/no-showw.png">
						</div>
						<div class="col-12 order-lg-2">
							<div class="pt-3">
								<h4 class="title text-center mb-3">Smanjite nedolaske</h4>
								<p class="description text-center">Vodimo evidenciju nedolazaka, kako biste mogli donijeti informiraniju odluku kod potvrđivanja rezervacije.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
<!--
		<div class="jumbotron paral paralsec">
			<div class="container">
				<div class="row text-center">
					<div class="col-md-3 py-3">
						<div class="counter">
							<i class="far fa-calendar-check fa-2x"></i>
							<h2 class="timer count-title count-number" :data-to="rezervacije" data-speed="2000">{{rezervacije}}</h2>
							<p class="count-text ">Rezervacija</p>
						</div>
					</div>
					<div class="col-md-3 py-3">
						<div class="counter">
							<i class="fas fa-users fa-2x"></i>
							<h2 class="timer count-title count-number" :data-to="korisnici" data-speed="2000">{{korisnici}}</h2>
							<p class="count-text ">Korisnika</p>
						</div>
					</div>
					<div class="col-md-3 py-3">
						<div class="counter">
							<i class="fas fa-store-alt fa-2x"></i>
							<h2 class="timer count-title count-number" :data-to="saloni" data-speed="2000">{{saloni}}</h2>
							<p class="count-text ">Salona</p>
						</div>
					</div>
					<div class="col-md-3 py-3">
						<div class="counter">
							<i class="fas fa-city fa-2x"></i>
							<h2 class="timer count-title count-number" data-to="5" data-speed="2000">5</h2>
							<p class="count-text ">Gradova</p>
						</div>
					</div>
				</div>
			</div>
		</div>
-->
		<!-- usluge /-->
		<section id="usluge" class="main-content-area py-3 py-md-5">
			<div class="container content-container">
				<div class="row">
					<div class="col-12 biz-section-title">
						<h3>Usluge</h3>
						<p>Naše usluge prilagođene su Vašim svakodnevnim potrebama.</p>
					</div>
				</div>
				<div class="row mt-5">
					<div class="col-md-4 box wow bounceInUp" data-wow-delay="0.1s" data-wow-duration="1.4s">
						<div class="icon"><i class="far fa-calendar-check"></i></div>
						<h4 class="title">Sistem za rezervacije</h4>
						<p class="description">Centralni pristup svim rezervacijama svih djelatnika salona, usklađenih s Vašim rasporedom rada.</p>
					</div>
					<div class="col-md-4 box wow bounceInUp" data-wow-delay="0.1s" data-wow-duration="1.4s">
						<div class="icon"><i class="far fa-calendar-alt"></i></div>
						<h4 class="title">Raspored rada</h4>
						<p class="description">Manipulacija radnim vremenom, smjenama i rasporedom djelatnika nikad nije bila brža i lakša.</p>
					</div>
					<div class="col-md-4 box wow bounceInUp" data-wow-delay="0.1s" data-wow-duration="1.4s">
						<div class="icon"><i class="far fa-list-alt"></i></div>
						<h4 class="title">Cjenik usluga</h4>
						<p class="description">Uz isticanje regularnih cijena za Vaše usluge, iskoristite mogućnost i promocije akcijskih cijena.</p>
					</div>
					<div class="col-md-4 box wow bounceInUp" data-wow-delay="0.1s" data-wow-duration="1.4s">
						<div class="icon"><i class="far fa-images"></i></div>
						<h4 class="title">Galerija radova</h4>
						<p class="description">Istaknite radove na koje ste najviše ponosni i predstavite se klijentima u najboljem svijetlu.</p>
					</div>
					<div class="col-md-4 box wow bounceInUp" data-wow-delay="0.1s" data-wow-duration="1.4s">
						<div class="icon"><i class="far fa-comments"></i></div>
						<h4 class="title">Komentari i recenzije</h4>
						<p class="description">Samo klijenti koji su koristili usluge Vašeg salona imaju mogućnost komentiranja i ocjenjivanja.</p>
					</div>
					<div class="col-md-4 box wow bounceInUp" data-wow-delay="0.1s" data-wow-duration="1.4s">
						<div class="icon"><i class="fas fa-chart-line"></i></div>
						<h4 class="title">Promocija salona</h4>
						<p class="description">Istaknite svoj salon na našoj stranici i tako postanite dostupniji široj publici.</p>
					</div>
				</div>
			</div>
		</section>

<!-- 
		<section id="cijene" class="main-content-area py-3 py-md-5">
			<div class="container content-container">
				<div class="row">
					<div class="col-12 biz-section-title">
						<h3>Planovi</h3>
						<p>Odaberite plan koji će se najbolje uklopiti u Vašu viziju poslovanja.</p>
					</div>
				</div>
				<div class="row mt-5">
					<div class="col-md-4">
						<div class="cijena-container">
							<div class="cijena-title cijena-start">
								<h3>Start</h3>
							</div>
							<div class="cijena-body">
								<h3>149 kn/mj</h3>
								<p><span><i class="fas fa-caret-right mr-3"></i></span>Neograničeno rezervacija<br>
									<span><i class="fas fa-caret-right mr-3"></i></span>Do 3 djelatnika<br>
									<span><i class="fas fa-caret-right mr-3"></i></span>Do 20 usluga<br>
									<span><i class="fas fa-caret-right mr-3"></i></span>Do 10 slika
								</p>
							</div>
						</div>
					</div>
					<div class="col-md-4">
						<div class="cijena-container">
							<div class="cijena-title cijena-standard">
								<h3>Standard</h3>
							</div>
							<div class="cijena-body">
								<h3>249 kn/mj</h3>
								<p><span><i class="fas fa-caret-right mr-3"></i></span>Neograničeno rezervacija<br>
									<span><i class="fas fa-caret-right mr-3"></i></span>Do 6 djelatnika<br>
									<span><i class="fas fa-caret-right mr-3"></i></span>Do 40 usluga<br>
									<span><i class="fas fa-caret-right mr-3"></i></span>Do 20 slika
								</p>
							</div>
						</div>
					</div>
					<div class="col-md-4">
						<div class="cijena-container">
							<div class="cijena-title cijena-premium">
								<h3>Premium</h3>
							</div>
							<div class="cijena-body">
								<h3>399 kn/mj</h3>
								<p><span><i class="fas fa-caret-right mr-3"></i></span>Neograničeno rezervacija<br>
									<span><i class="fas fa-caret-right mr-3"></i></span>Neograničeno djelatnika<br>
									<span><i class="fas fa-caret-right mr-3"></i></span>Neograničeno usluga<br>
									<span><i class="fas fa-caret-right mr-3"></i></span>Do 50 slika<br>
									<span><i class="fas fa-caret-right mr-3"></i></span>Istaknuto na početnoj<br>
									<span><i class="fas fa-caret-right mr-3"></i></span>1 promocija kvartalno
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
-->
		<!-- usluge /-->
		<section id="biz-ad" class="main-content-area py-5">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-md-5 mb-3 mb-md-0">
						<img class="img-responsive" src="img/uspjeh.png">
					</div>
					<div class="col-md-7 text-center text-md-left">
						<h3 class="title title-biz-zadnji my-4">Ako želiš ići brzo, idi sam. Ako želiš ići daleko, idemo zajedno.</h3>
						<a href="/kontakt" class="btn fs-btn dark">Kontaktirajte nas</a>
					</div>
				</div>
			</div>
		</section>

		<home-footer></home-footer>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex';
	export default {
		name: 'biz',
		computed: {
			...mapState({
				saloni: (state) => state.stats.saloni,
				korisnici: (state) => state.stats.korisnici,
				rezervacije: (state) => state.stats.rezervacije
			})
		},
		created() {
			this.getStats();
		},
		methods: {
			getStats: function() {
				this.$store.dispatch('get', this.$store.state.endpoint + "get-stats").then((data) => {
					this.$store.state.stats = data.data;
				})
			}
		}
	}

</script>
